module.exports = __webpack_public_path__ + "img/groups_black_32dp_30@2x.3b739bc0.png";